import { render, staticRenderFns } from "./ContactNotFound.vue?vue&type=template&id=27b01d5c&scoped=true&"
import script from "./ContactNotFound.vue?vue&type=script&lang=js&"
export * from "./ContactNotFound.vue?vue&type=script&lang=js&"
import style0 from "./ContactNotFound.vue?vue&type=style&index=0&id=27b01d5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b01d5c",
  null
  
)

export default component.exports